/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Yoga_TermsInputs */

const en_service_type_yoga_terms = /** @type {(inputs: Service_Type_Yoga_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yoga, vinyasa, hatha, ashtanga, yin`)
};

const pl_service_type_yoga_terms = /** @type {(inputs: Service_Type_Yoga_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`joga, yoga, vinyasa, hatha, ashtanga, yin`)
};

/**
* | output |
* | --- |
* | "yoga, vinyasa, hatha, ashtanga, yin" |
*
* @param {Service_Type_Yoga_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_yoga_terms = /** @type {((inputs?: Service_Type_Yoga_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Yoga_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_yoga_terms(inputs)
	return en_service_type_yoga_terms(inputs)
});